export const KEY_FILTER_MEDIA_STATUS = [
  { label: "active", value: true },
  { label: "Inactive", value: false },
];

export const KEY_FILTER_MEDIA_TYPE = [
  { label: "gif", value: "gif" },
  { label: "png", value: "png" },
  { label: "jpg", value: "jpg" },
  { label: "jpeg", value: "jpeg" },
  { label: "bmp", value: "bmp" },
  { label: "mp4", value: "mp4" },
  { label: "mpg", value: "mpg" },
  { label: "mpeg", value: "mpeg" },
  { label: "mov", value: "mov" },
  { label: "avi", value: "avi" },
];
